<template>
  <section class="section container pt-0">
    <div class="container mt-0 pb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("account module settings") }}
      </h1>
    </div>

    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="account_types"
          @click="change_active_tab($event, this)"
        >
          <a>
            <span class="icon">
              <i class="fa fa-bank"></i>
            </span>
            <span>{{ $t("account types") }}</span>
          </a>
        </li>
        <li data-tab="movement_types" @click="change_active_tab($event, this)">
          <a>
            <span class="icon">
              <i class="fa fa-list"></i>
            </span>
            <span>{{ $t("movement types") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="container" ref="contents">
      <div class="" data-tab="account_types">
        <account-types-datatable />
      </div>
      <div class="is-hidden" data-tab="movement_types">
        <movement-types-datatable />
      </div>
    </div>

    <!-- <div>
      <div class="field">
        <div class="control">
          <button class="button is-primary" @click="save">Guardar</button>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  change_active_tab,
} from "@/utils";
import AccountTypesDatatable from "./account_types_datatable/Index.vue";
import MovementTypesDatatable from "./movement_types_datatable/Index.vue";

export default {
  name: "AccountSettings",
  components: { AccountTypesDatatable, MovementTypesDatatable },
  data() {
    return {};
  },
  methods: {
    change_active_tab,
    save() {
      let data = this.$data;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {})
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
